export default "__VITE_ASSET__mWee7W$k__"